export default __webpack_public_path__ + "static/media/servicesBox.9d89c5b7.png";